// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".one-click-modal__response{margin-bottom:15px;padding:15px 0;text-align:center;background-color:#f9fafb}.one-click-modal__response-order{margin-bottom:10px;font-size:28px;font-weight:700;line-height:32px}", ""]);
// Exports
module.exports = exports;
